import React, { Suspense, useEffect, useState, useContext } from "react";
import { lazy } from "react";
import {
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Prepare from "../screens/prepare";
import Leading from "../screens/leading";
import LandingPage from "../screens/landing";
// import ChoosePlan from "../screens/choosePlans";
import ForgotPassword from "../screens/forgotPassword";
import TestReview from "../screens/test/testReview";
import QuestionReview from "../screens/questionReview";
import Profile from "../screens/profile";
import Account from "../screens/profile/account";
import TestSetting from "../screens/profile/components/testSetting";
import OtherApps from "../screens/otherApps";
import HelpAndSupport from "../screens/helpAndSupport";
import MainLayout from "./layout/MainLayout";
import Glossary from "../screens/glossary";
// import Acronyms from "../screens/acronyms";
import StudyQuestion from "../screens/studyQuestion";
import QuickSet from "../screens/quickSet";
import PracticeTest from "../screens/practiceTest";
import FlashCards from "../screens/flashCards";
import QuickSets from "../screens/flashCards/QuickSets";
import CustomTestBuilder from "../screens/customTestBuilder";
import Articles from "../screens/articles";
import Article from "../screens/articles/article";
// import Home from "../screens/home";
import Dashboard from "../screens/dashboard/dashboard";
import History from "../screens/history";
import Bookmark from "../screens/bookmark";
import Test from "../screens/test";
import MainBookmark from "../screens/MainBookmark";
import ChangeApperance from "../screens/changeApperance";
import PrepareBundle from "../screens/prepareBundle";
import { IS_BUNDLE_APP } from "../../app_constant";
import Loader from "./loader";
import Questions from "../screens/studyQuestion/questions";
import { AuthContext } from "../context/AuthProvider";
import { BundleContext } from "../context/BundleProvider";

import Exam from "../screens/onboard/exam";


import UserExamSchedule from "../screens/UserExamSchedule";
import OnboardingTest from "../screens/onboard/OnboardingTest";
import OnboardingTestReview from "../screens/onboard/OnboardingTestReview";
import OnboardingQuestionReview from "../screens/onboard/OnboardingQuestionReview";

const Acronyms = lazy(() => import("../screens/acronyms"));
const Home = lazy(() => import("../screens/home"));
const ChoosePlan = lazy(() => import("../screens/choosePlans"));

const QOTDAnswerScreen = lazy(() => import("../screens/qotd/QOTDAnswerScreen"));
const QOTDExplanationScreen = lazy(() => import("../screens/qotd/QOTDExplanationScreen"));
const QOTDHistory = lazy(() => import("../screens/qotd/QOTDHistory"));

const PageRouter = () => {
  const [isReloading, setIsReloading] = useState(false);
  const location = useLocation();
  const { isAuthenticated, isAuthLoading } = useContext(AuthContext);
  const { selectedCertificate } = useContext(BundleContext);

  // Redirect authenticated bundle-app users to /prepare when no certificate is set
  // Prepare handles initialization and shows select-exam modal for first-time users
  const needsPrepareRedirect =
    isAuthenticated &&
    IS_BUNDLE_APP &&
    !selectedCertificate &&
    location.pathname !== "/prepare";

  const handleReload = () => {
    setIsReloading(true);
    // Reset reloading state after a short delay to prevent stuck loading state
    setTimeout(() => {
      setIsReloading(false);
    }, 100);
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleReload);
    // Cleanup the subscription when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleReload);
    };
  }, []);

  // Show loader only when auth is loading or during reload
  if (isAuthLoading || isReloading) {
    return <Loader />;
  }

  // Redirect to prepare when authenticated but no certificate (first-time or refresh)
  if (needsPrepareRedirect) {
    return <Navigate to="/prepare" replace />;
  }

  return (
    <>
      {!isAuthenticated ? (
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/leading" element={<Leading />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/forgot_password" element={<ForgotPassword />} />
            <Route path="/welcome" element={<Exam />} />
            <Route path="/onboarding-test" element={<OnboardingTest />} />
            <Route path="/onboarding-test-review" element={<OnboardingTestReview />} />
            <Route path="/onboarding-question-review" element={<OnboardingQuestionReview />} />
            <Route path="/questionReview" element={<QuestionReview />} />
            <Route path="/exam" element={<Exam />} />
            <Route
              path="/prepare"
              element={
                IS_BUNDLE_APP ? (
                  <PrepareBundle handleReload={handleReload} />
                ) : (
                  <Prepare />
                )
              }
            />
            <Route element={<MainLayout />}>
              <Route path="/home" element={<Home />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </Suspense>
      ) : (
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route
              path="/prepare"
              element={
                IS_BUNDLE_APP ? (
                  <PrepareBundle handleReload={handleReload} />
                ) : (
                  <Prepare />
                )
              }
            />
            <Route element={<MainLayout />}>
              <Route path="/choosePlan" element={<ChoosePlan />} />
              <Route path="/testReview" element={<TestReview />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/account" element={<Account />} />
              <Route path="/appearance" element={<ChangeApperance />} />
              <Route path="/testSetting" element={<TestSetting />} />
              <Route path="/otherApps" element={<OtherApps />} />
              <Route path="/helpAndSupport" element={<HelpAndSupport />} />
              <Route path="/glossary" element={<Glossary />} />
              <Route path="/acronyms" element={<Acronyms />} />
              <Route path="/studyQuestion" element={<StudyQuestion />} />
              <Route path="/quick" element={<QuickSet />} />
              <Route path="/practicetest" element={<PracticeTest />} />
              <Route path="/flashcard" element={<FlashCards />} />
              <Route path="/flashcard/quick" element={<QuickSets />} />
              <Route path="/flashcard/questions" element={<QuickSets />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/article" element={<Article />} />
              <Route path="/customtest" element={<CustomTestBuilder />} />
              <Route path="/home" element={<Home />} />
              <Route path="*" element={<Home />} />
              <Route path="/studyquestions/:id" element={<Questions />} />
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/history" element={<History />} />
              <Route path="/Bookmark" element={<MainBookmark />} />
              <Route path="/Bookmark/questions" element={<Bookmark />} />
              <Route path="/test" element={<Test />} />
              <Route path="/questionReview" element={<QuestionReview />} />
              <Route path="/user-exam-schedule" element={<UserExamSchedule />} />
              <Route path="/qotd/answer" element={<QOTDAnswerScreen />} />
              <Route path="/qotd/explanation" element={<QOTDExplanationScreen />} />
              <Route path="/qotd/history" element={<QOTDHistory />} />
            </Route>
          </Routes>
        </Suspense>
      )}
    </>
  );
};

export default PageRouter;
